import React, {useContext, useEffect, useRef, useState} from 'react';
import {Box, Button, Stack, Typography, useMediaQuery} from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {useClientApi} from '../../api/client';
import {getClientConfig} from '../../config/clientThemes';
import mainLogo from '../../images/black_letters_with_blue_shadow.svg';
import {Link} from 'react-router-dom';
import ShareButtons from '../../components/buttons/ShareButtons';
import {CATEGORY_MAP} from './Components/analysis/parseRecoProducts';
import HealthCategoryNav from '../../components/NavigationBar/HealthCategoryNavigationBar';
import {useProductsApi} from '../../api/products';
import APIObjectsContext from '../../context/APIObjectsContext';
import useGeoLocation from 'react-ipgeolocation';
import {identifyClientType} from '../../utils/identifyClientType';
import {CLIENT_TYPES} from '../../api/clientconfig';

const ShowAllProductsPage = ({
  sortedMetricsByHealthOrder,
  blurAndHide,
  handleNavigation,
  onBackBtnClick,
  getCategories,
  activeCategoryIndex,
  handleCategorySelect,
  item,
}) => {
  console.log(sortedMetricsByHealthOrder);

  console.log('sortedMetricsByHealthOrder in main page', sortedMetricsByHealthOrder);
  const cardRef = useRef(null);
  const productsApi = useProductsApi();
  const getUserCountryLocation = useGeoLocation();
  const {userAssessmentID, setUserAssessmentID} = useContext(APIObjectsContext);
  const [userCountryLocation, setUserCountryLocation] = useState('');

  const [ShadowClass, setShadowClass] = useState(true);
  const isSmallScreen = useMediaQuery('(max-width:499px)');
  const isGalaxyFold = useMediaQuery('(max-width:280px)');
  const [clientType, setClientType] = useState(CLIENT_TYPES.DEFAULT);
  const config = getClientConfig(clientType);
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const clientApi = useClientApi(clientType);

  const cssToBlurAndHideCard = {
    filter: blurAndHide ? 'blur(10px)' : 'blur(0px)',
    pointerEvents: blurAndHide ? 'none' : 'auto',
  };
  // useEffect(() => {
  //     // Determine client type based on your authentication or route
  //     const determineClientType = () => {
  //         const fromDoktor = window.localStorage.getItem('from_doktor');
  //         if (fromDoktor === 'true') {
  //             return CLIENT_TYPES.DOKTOR_CONNECT;
  //         }
  //         // Add logic for ATP detection
  //         const fromATP = window.localStorage.getItem('from_atp');
  //         if (fromATP === 'true') {
  //             return CLIENT_TYPES.ATP;
  //         }
  //         return CLIENT_TYPES.DEFAULT;
  //     };

  //     setClientType(determineClientType());
  // }, []);

  useEffect(() => {
    setClientType(identifyClientType());
  }, []);

  const [orgProductsList, setOrgProductsList] = useState([]);

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(getUserCountryLocation, userCountryLocation);

    if (getUserCountryLocation.error) {
      setUserCountryLocation(null); // If there's an error, set the location to null
    } else if (getUserCountryLocation.country && !userCountryLocation) {
      setUserCountryLocation(getUserCountryLocation.country); // Set geoLocation once when it's available
    }
  }, [getUserCountryLocation]); // Run when geoLocation or error changes

  useEffect(() => {
    const fetchTopProducts = async () => {
      let response;
      const sessionId = localStorage.getItem('session-id');

      try {
        setLoading(true);
        if (clientType == CLIENT_TYPES.DEFAULT && (userCountryLocation || userCountryLocation === null)) {
          //Create product recommendation for the user
          await productsApi.createProductRecommendation(userAssessmentID, userCountryLocation);

          // Fetch the recommended products for aimd flow
          response = await productsApi.getRecommendedProducts(userAssessmentID);
        } else if (sessionId) {
          response = await clientApi.getProductRecommendations(sessionId);
        }

        // if no response at all just return do nothing
        if (response === undefined) {
          setLoading(false);
          return;
        }
        // Only process if the response is successful
        if (response?.status === 200 && response?.data) {
          console.log(response.data);
          const topProducts = getTop3Products(response);
          // Format the top 3 products
          const formattedTopProducts = topProducts.map(product => ({
            id: product.product_id || Math.random(), // Use product ID if available, else generate a random ID
            name: product.product_name || product?.name,
            description: product.product_description || product?.reason,
            restrictions: product.product_restrictions,
            amazonAffiliateLink: product.product_link,
            productImageAddress: product.product_image_address,
            brand: product.product_brand,
            reason: product.reason,
            vitalName: product.vital_name || null,
            vitalValue: product.vital_value || null,
            brandImageAddress: product.brand_image_address,
          }));
          setOrgProductsList(formattedTopProducts); // Set the top 3 unique products in state
          setLoading(false);
          setError(null); // Clear any errors
        } else {
          setError('Error fetching products');
        }
      } catch (error) {
        console.error('Error fetching top products:', error);
        setError('Error fetching products');
      } finally {
        setLoading(false); // End loading
      }
    };
    fetchTopProducts();
  }, [userCountryLocation, clientType]);

  //get top 3 products
  const getTop3Products = prodRes => {
    let symptomRelatedProducts = [];
    if (prodRes.data && prodRes.data.symptoms) {
      symptomRelatedProducts = prodRes.data.symptoms;
    }

    const recommendedProducts = [];
    const seenProductIds = new Set(); // To track product IDs and avoid duplicates

    // Step 1: Add symptom-related products first (avoid duplicates)
    symptomRelatedProducts.forEach(product => {
      if (!seenProductIds.has(product.product_id)) {
        recommendedProducts.push(product);
        seenProductIds.add(product.product_id); // Track this product
      }
    });

    // Step 2: Process the categories in sortedMetricsByHealthOrder
    if (Array.isArray(sortedMetricsByHealthOrder)) {
      sortedMetricsByHealthOrder.forEach(item => {
        if (item?.category) {
          const categories = CATEGORY_MAP[item?.category];

          if (categories && categories.length) {
            categories.forEach(category => {
              // Step 3: Check if the category exists as a key in prodRes.data
              if (prodRes.data && prodRes.data.hasOwnProperty(category)) {
                // Get the products for this category
                const categoryProducts = prodRes.data[category];

                // Step 4: Add products to recommendedProducts array if not already added
                categoryProducts.forEach(product => {
                  if (!seenProductIds.has(product.product_id)) {
                    recommendedProducts.push(product);
                    seenProductIds.add(product.product_id); // Track this product
                  }
                });
              }
            });
          }
        }
      });
    }

    // Combine symptom-related and recommended products
    const allRecommendedProducts = [...recommendedProducts];

    //If total recommended products are less than 3, try to add products from 'products' key
    if (allRecommendedProducts.length < 3 && prodRes.data && prodRes.data.hasOwnProperty('products')) {
      const additionalProducts = prodRes.data.products;

      additionalProducts.forEach(product => {
        if (!seenProductIds.has(product.product_id) && allRecommendedProducts.length < 3) {
          allRecommendedProducts.push(product);
          seenProductIds.add(product.product_id);
        }
      });
    }

    //If total recommended products are less than 3, just search for any products and add
    if (allRecommendedProducts.length < 3 && prodRes.data && prodRes.data.products) {
      const availableProducts = prodRes.data.products;

      availableProducts.forEach(product => {
        if (!seenProductIds.has(product.product_id) && allRecommendedProducts.length < 3) {
          allRecommendedProducts.push(product);
          seenProductIds.add(product.product_id);
        }
      });
    }

    // If total products are more than 3, slice the array to only include the first 3
    const top3Products = allRecommendedProducts.slice(0, 3);

    console.log('Top 3 Recommended Products:', top3Products);

    return top3Products;
  };
  const handleRedirect = link => {
    // Redirect to the Amazon link in a new tab
    window.open(link, '_blank');
  };
  return isLargeScreen ? (
    <Stack className="result-page-card" padding={3}>
      <Box
        sx={{
          // backgroundColor: "#FFF",
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          // marginTop : "24px",
          // paddingBottom : "10px"
        }}
        className="results-page-wrapper"
      >
        <Stack className="result-page-card large-card" padding={isGalaxyFold ? 1 : 2}>
          <Stack className="large-result-component">
            <Stack
              sx={{
                minHeight: '380px !important',
              }}
              className={ShadowClass ? 'result-component card-gradient large' : 'result-component large'}
            >
              {orgProductsList?.length ? (
                orgProductsList.slice(0, 3).map((data, index) => (
                  <Box
                    key={index}
                    sx={{
                      borderRadius: '15px',
                      padding: '4px 16px',
                      ...cssToBlurAndHideCard,
                    }}
                  >
                    <Stack display="flex" flexDirection="row" justifyContent="space-between" gap={1}>
                      <Stack flex="6">
                        <Typography
                          // onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                          sx={{
                            fontSize: '16px',
                            fontWeight: 600,
                            color: '#000000',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            WebkitLineClamp: 1,
                          }}
                        >
                          {data?.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 500,
                            color: '#000000',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            WebkitLineClamp: 2, // Limit to 3 lines
                          }}
                        >
                          {data.reason}
                        </Typography>
                        <Button
                          sx={{
                            color: clientType === CLIENT_TYPES.DEFAULT ? '#72D8DA' : '#F15C30',
                            padding: '4px',
                            display: 'flex',
                            justifyContent: 'start',
                            padding: '2px',
                            '&:hover': {
                              backgroundColor: 'transparent', // Make hover state the same as normal state
                              background: 'transparent',
                            },
                          }}
                          onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                        >
                          <Typography
                            sx={{
                              fontSize: '20px',
                              backgroundColor: clientType === CLIENT_TYPES.DEFAULT ? '#72D8DA' : '#F15C30',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '6px',
                              width: '28px',
                              height: '28px',
                            }}
                          >
                            <AddShoppingCartIcon sx={{color: 'white', fontSize: '18px'}} />
                          </Typography>
                          View Product
                        </Button>
                      </Stack>
                      <Stack display="flex" justifyContent="center" alignItems="center" flex="3">
                        <Box>
                          <img src={data.productImageAddress} style={{width: '50px', height: 'auto'}}></img>
                        </Box>
                      </Stack>
                    </Stack>
                  </Box>
                ))
              ) : (
                <Box sx={{height: '150px', textAlign: 'center', padding: '20px 0px'}}>
                  {loading ? (
                    <Typography color="grey" fontSize="16px" marginY={2}>
                      Loading...
                    </Typography>
                  ) : (
                    <Typography>No Product Data Found</Typography>
                  )}
                </Box>
              )}
              <Box className="result-logo" sx={{marginBottom: '0px', paddingTop: '4px'}}>
                <img src={config.logos.main} height={config.logos.height} className="" />
                {clientType !== CLIENT_TYPES.DEFAULT && (
                  <Typography sx={{fontSize: '14px'}}>
                    Your health scan was powered by
                    <img src={mainLogo} className="custom-main-logo-for-md" />
                  </Typography>
                )}
              </Box>
            </Stack>
            {/* </Box> */}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  ) : (
    <Box
      sx={{
        backgroundColor: '#FFF',
        // minHeight: "100vh",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        padding: isLargeScreen ? '20px' : isSmallScreen ? '4px 20px' : '10px 20px',
      }}
      className="results-page-wrapper"
    >
      <Stack className="result-page-card" sx={{backgroundColor: '#fff'}}>
        <Box style={{textDecoration: 'none', width: '100%', display: 'flex', justifyContent: 'space-between'}}>
          <Stack onClick={onBackBtnClick} display="flex" flexDirection="row" style={{cursor: 'pointer'}}>
            {config?.backButton}
          </Stack>
        </Box>
        <Stack>
          <Stack>
            <Typography
              fontSize={isSmallScreen ? '14' : '18px'}
              fontWeight="700"
              color="#545454"
              textAlign="center"
              marginTop={isSmallScreen ? '2px' : '4px'}
              lineHeight={isSmallScreen ? '16px' : '30px'}
              marginBottom="4px"
            >
              Top Products for You
            </Typography>
            <Typography
              sx={{
                color: '#545454',
                fontFamily: 'Poppins',
                fontSize: isSmallScreen ? '12px' : '14px',
                fontWeight: 600,
                lineHeight: isSmallScreen ? 1.2 : 1.5,
                textAlign: 'center',
              }}
            >
              Our recommendations to elevate your health in your weakest health categories.
            </Typography>
          </Stack>
          {/* <Box > */}
          <Stack
            ref={cardRef}
            sx={{position: 'relative', bottom: '25px'}}
            className={`${ShadowClass ? 'result-component card-gradient' : 'result-component'} result-component-org`}
          >
            {orgProductsList?.length ? (
              orgProductsList.slice(0, 3).map((data, index) => (
                <Box
                  key={index}
                  sx={{
                    // minHeight: '136px',
                    // width: '300px',
                    // padding: '2px',
                    // boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1),0px 4px 23px rgba(0, 0, 0, 0.04)',
                    borderRadius: '15px',
                    padding: isSmallScreen ? '1px 12px 5px 12px' : '4px 14px',
                    ...cssToBlurAndHideCard,
                  }}
                >
                  <Stack display="flex" flexDirection="row" justifyContent="space-between" gap={1}>
                    <Stack flex="6">
                      <Typography
                        // onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                        sx={{
                          fontSize: isSmallScreen ? '13px' : '16px',

                          fontWeight: 600,
                          color: '#000000',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          WebkitLineClamp: 1,
                        }}
                      >
                        {data?.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: isSmallScreen ? '11px' : '14px',
                          fontWeight: 500,
                          color: '#000000',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          lineHeight: isSmallScreen ? 1.2 : 1.3,
                          WebkitLineClamp: 2, // Limit to 3 lines
                        }}
                      >
                        {data.reason}
                      </Typography>
                      <Button
                        onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                        sx={{
                          color: clientType === CLIENT_TYPES.DEFAULT ? '#72D8DA' : '#F15C30',
                          fontSize: isSmallScreen ? '12px' : '15px',

                          display: 'flex',
                          justifyContent: 'start',
                          padding: '4px 4px 4px 0px',
                          '&:hover': {
                            backgroundColor: 'none', // Make hover state the same as normal state
                            background: 'transparent',
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '20px',
                            backgroundColor: clientType === CLIENT_TYPES.DEFAULT ? '#72D8DA' : '#F15C30',

                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '6px',
                            width: isSmallScreen ? '22px' : '28px',
                            height: isSmallScreen ? '22px' : '28px',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          <AddShoppingCartIcon sx={{color: 'white', fontSize: isSmallScreen ? '14px' : '18px'}} />
                        </Typography>
                        View Product
                      </Button>
                    </Stack>
                    <Stack display="flex" justifyContent="center" alignItems="center" flex="3">
                      <Box
                      // onClick={() => handleRedirect(data?.amazonAffiliateLink)}
                      >
                        <img
                          src={data.productImageAddress}
                          style={{width: isSmallScreen ? '40px' : '50px', height: 'auto'}}
                        ></img>
                      </Box>
                      {/* <Typography textAlign="center" fontSize="12px" fontWeight="600" color="#F15C30" paddingTop="8px">See Predicted Health Effects</Typography> */}
                    </Stack>
                  </Stack>
                </Box>
              ))
            ) : (
              <Box sx={{height: '150px', textAlign: 'center', padding: '20px 0px'}}>
                {loading ? (
                  <Typography color="grey" fontSize="14px" marginY={2}>
                    Loading...
                  </Typography>
                ) : (
                  <Typography> No Product Data Found </Typography>
                )}
              </Box>
            )}
            <Box className="result-logo" sx={{bottom: '6px !important', paddingTop: '4px !important'}}>
              <img src={config.logos.main} height={config.logos.height} className="" />
              {clientType !== CLIENT_TYPES.DEFAULT && (
                <Typography
                  sx={{
                    fontSize: isGalaxyFold ? '8px' : '10px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    paddingTop: '8px',
                    justifyContent: 'center',
                  }}
                >
                  Your health scan was powered by
                  <img src={mainLogo} className="custom-main-logo" />
                </Typography>
              )}
            </Box>
          </Stack>
          {/* </Box> */}
        </Stack>
        <Box sx={{position: 'relative', bottom: '25px'}}>
          <HealthCategoryNav
            categories={getCategories}
            activeIndex={activeCategoryIndex}
            onSelectCategory={handleCategorySelect}
            isLargeScreen={false}
            clientBaseNavCss={{
              arrowColor: config?.resultPageSlider?.arrowColor,
              arrowHOverColor: config?.resultPageSlider?.arrowHOverColor,
              movingIndicatorColor: config?.resultPageSlider?.movingIndicatorColor,
              startIconColorActive: config?.resultPageSlider?.startIconColorActive,
            }}
          />
        </Box>

        <Box>
          <>
            <Button
              fullWidth
              onClick={handleNavigation}
              className={'btn-shadow'}
              sx={{
                height: isSmallScreen ? '50px' : '60px',
                borderRadius: '10px',
                marginBottom: isSmallScreen ? '6px' : '10px',
                background: config.button.background,
                maxWidth: '400px',
                textAlign: 'center',
                color: '#fff',
                '&:hover': {
                  color: 'black',
                },
              }}
            >
              <Typography
                className="btn-txt"
                variant="p"
                component="p"
                fontWeight="600"
                sx={{
                  fontSize: isSmallScreen ? '16px' : '20px',
                }}
              >
                Learn More
              </Typography>
            </Button>

            <ShareButtons socialButtonsCss={config?.socialButtons} cardRef={cardRef} />
            {/* Footer Starts */}
            {/* <ShareButtons cardRef={ cardRef } item={ item } socialButtonsCss={config?.socialButtons} /> */}
            {/* Footer Ends */}
          </>
        </Box>
      </Stack>
    </Box>
  );
};

export default ShowAllProductsPage;
